// This file is generated automatically by `scripts/build/indices.ts`. Please, don't change it.
export * from "./locale/af.mjs";
export * from "./locale/ar.mjs";
export * from "./locale/ar-DZ.mjs";
export * from "./locale/ar-EG.mjs";
export * from "./locale/ar-MA.mjs";
export * from "./locale/ar-SA.mjs";
export * from "./locale/ar-TN.mjs";
export * from "./locale/az.mjs";
export * from "./locale/be.mjs";
export * from "./locale/be-tarask.mjs";
export * from "./locale/bg.mjs";
export * from "./locale/bn.mjs";
export * from "./locale/bs.mjs";
export * from "./locale/ca.mjs";
export * from "./locale/ckb.mjs";
export * from "./locale/cs.mjs";
export * from "./locale/cy.mjs";
export * from "./locale/da.mjs";
export * from "./locale/de.mjs";
export * from "./locale/de-AT.mjs";
export * from "./locale/el.mjs";
export * from "./locale/en-AU.mjs";
export * from "./locale/en-CA.mjs";
export * from "./locale/en-GB.mjs";
export * from "./locale/en-IE.mjs";
export * from "./locale/en-IN.mjs";
export * from "./locale/en-NZ.mjs";
export * from "./locale/en-US.mjs";
export * from "./locale/en-ZA.mjs";
export * from "./locale/eo.mjs";
export * from "./locale/es.mjs";
export * from "./locale/et.mjs";
export * from "./locale/eu.mjs";
export * from "./locale/fa-IR.mjs";
export * from "./locale/fi.mjs";
export * from "./locale/fr.mjs";
export * from "./locale/fr-CA.mjs";
export * from "./locale/fr-CH.mjs";
export * from "./locale/fy.mjs";
export * from "./locale/gd.mjs";
export * from "./locale/gl.mjs";
export * from "./locale/gu.mjs";
export * from "./locale/he.mjs";
export * from "./locale/hi.mjs";
export * from "./locale/hr.mjs";
export * from "./locale/ht.mjs";
export * from "./locale/hu.mjs";
export * from "./locale/hy.mjs";
export * from "./locale/id.mjs";
export * from "./locale/is.mjs";
export * from "./locale/it.mjs";
export * from "./locale/it-CH.mjs";
export * from "./locale/ja.mjs";
export * from "./locale/ja-Hira.mjs";
export * from "./locale/ka.mjs";
export * from "./locale/kk.mjs";
export * from "./locale/km.mjs";
export * from "./locale/kn.mjs";
export * from "./locale/ko.mjs";
export * from "./locale/lb.mjs";
export * from "./locale/lt.mjs";
export * from "./locale/lv.mjs";
export * from "./locale/mk.mjs";
export * from "./locale/mn.mjs";
export * from "./locale/ms.mjs";
export * from "./locale/mt.mjs";
export * from "./locale/nb.mjs";
export * from "./locale/nl.mjs";
export * from "./locale/nl-BE.mjs";
export * from "./locale/nn.mjs";
export * from "./locale/oc.mjs";
export * from "./locale/pl.mjs";
export * from "./locale/pt.mjs";
export * from "./locale/pt-BR.mjs";
export * from "./locale/ro.mjs";
export * from "./locale/ru.mjs";
export * from "./locale/se.mjs";
export * from "./locale/sk.mjs";
export * from "./locale/sl.mjs";
export * from "./locale/sq.mjs";
export * from "./locale/sr.mjs";
export * from "./locale/sr-Latn.mjs";
export * from "./locale/sv.mjs";
export * from "./locale/ta.mjs";
export * from "./locale/te.mjs";
export * from "./locale/th.mjs";
export * from "./locale/tr.mjs";
export * from "./locale/ug.mjs";
export * from "./locale/uk.mjs";
export * from "./locale/uz.mjs";
export * from "./locale/uz-Cyrl.mjs";
export * from "./locale/vi.mjs";
export * from "./locale/zh-CN.mjs";
export * from "./locale/zh-HK.mjs";
export * from "./locale/zh-TW.mjs";
